/**
 * Branded type and type guard for a 6-digit numeric string.
 * Use this to ensure values are exactly 6 digits and numeric.
 */

export type SixDigitCode = string & { __brand: 'SixDigitCode' };

/**
 * Type guard to check if a string is a valid 6-digit numeric code.
 * @param code - The string to validate.
 * @returns True if the string is exactly 6 digits, false otherwise.
 */
export function isSixDigitCode(code: string): code is SixDigitCode {
  return /^\d{6}$/.test(code);
}
